import { SgdfUserMenu } from './UserMenu.js';
window.customElements.define('sgdf-user-menu', SgdfUserMenu);
//# sourceMappingURL=sgdf-user-menu.js.map